import { useState } from "react";

export default function Popup({
  children,
  btnLabel,
  onBtnClick,
  disabled,
}: {
  children: any;
  btnLabel: string;
  onBtnClick?: any;
  disabled?: boolean;
}) {
  const [open, setOpen] = useState(true);

  return (
    <>
      {open && (
        <div className="fixed z-20 inset-0 overflow-y-auto bg-black bg-opacity-50">
          <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>

            <div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full sm:p-6 z-10">
              <div>
                <div className="mt-3 sm:mt-5">{children}</div>
              </div>
              <div className="mt-5 sm:mt-6">
                <button
                  type="button"
                  disabled={disabled}
                  className="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 my-4 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm"
                  onClick={() => {
                    if (typeof onBtnClick === "function") onBtnClick();
                    setOpen(false);
                  }}
                >
                  {btnLabel}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
